import api from '../api/axios';

export interface Supplier {
  id?: number;
  name: string;
  code?: string;
  contactPerson?: string;
  email: string;
  phone?: string;
  mobile?: string;
  address?: string;
  city?: string;
  country?: string;
  taxNumber?: string;
  paymentTerms?: string;
  creditLimit?: number;
  notes?: string;
  isActive?: boolean;
  website?: string;
}

const SupplierService = {
  getAll: (params?: any) => api.get('/suppliers', { params }),
  getOne: (id: number) => api.get(`/suppliers/${id}`),
  create: (data: Supplier) => api.post('/suppliers', { data }),
  update: (id: number, data: Partial<Supplier>) => api.put(`/suppliers/${id}`, { data }),
  delete: (id: number) => api.delete(`/suppliers/${id}`),
};

export default SupplierService;

